import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { useTranslation } from 'react-i18next';

function OffcanvasCreateFAQ({ show, onHide, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Create new FAQ')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Frequently-Asked-Question')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* FAQ */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title">{t('Question')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            id="title"
                                            placeholder={t('Enter FAQ Question')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* FAQ Answer */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="content">{t('Answer')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            id="content"
                                            placeholder={t('Enter FAQ Answer')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Categories')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    { /* FAQ Categories */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="categories">{t('FAQ Categories')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="categories"
                                            placeholder={t('Enter FAQ Categories')}
                                            onBlur={(e) => {
                                                const formattedValue = e.target.value.toLowerCase().replace(/\s+/g, '');
                                                e.target.value = formattedValue;
                                            }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Create new FAQ')}
                                </>
                            ) : (
                                t('Create new FAQ')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasCreateFAQ;